import HomeIcon from '@mui/icons-material/Home';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ArchiveIcon from '@mui/icons-material/Archive';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import HubIcon from '@mui/icons-material/Hub';

export const NavIcons = {
  IconInternal: <Diversity2Icon />,
  IconHome: <HomeIcon />,
  IconProjects: <HubIcon />, //
  IconClients: <BusinessCenterIcon />,
  IconUserManagement: <ManageAccountsIcon />,
  IconVersion: <AccountTreeIcon />,
  IconArchive: <ArchiveIcon />,
};

export default function getNavIcon(iconName) {
  const icon = NavIcons[iconName];
  return icon || NavIcons.IconProjects;
}
